import { parseAicopyBalanceNum } from "./aicopyCurrencies";
import { AICOPY_ORDER_OPTION_VOUCHER } from "./aicopyOrderOptions";
import {
  computeAicopyStrategyCardAmountBounds,
  getAicopyEffectiveMinMax,
} from "./strategyCardAmountBounds";
import { isVoucherItemSelectableForFollow } from "./voucherFollowRange";

/** 用券下单：策略卡片的 min/max 区间（与列表 OrderForm 一致） */
export function computeAicopyStrategyVoucherRangeBounds(detail, availableBalance = "0") {
  if (!detail || detail.minAmountPerUser == null) return null;
  const minUsdt = Number(detail.minAmountPerUser);
  const maxUsdt = detail.maxAmountPerUser != null ? Number(detail.maxAmountPerUser) : 10000;
  const currentAvailableNum = parseAicopyBalanceNum(availableBalance);
  const { effectiveMin, maxForSliderCap, validationMaxCap } = getAicopyEffectiveMinMax({
    minUsdt,
    maxUsdt,
    currency: AICOPY_ORDER_OPTION_VOUCHER,
    rate: 1,
    convertConfig: null,
    currentAvailableNum,
  });
  if (!Number.isFinite(effectiveMin) || effectiveMin <= 0) return null;
  const { minIn, maxInForValidation: maxIn } = computeAicopyStrategyCardAmountBounds({
    effectiveMin,
    maxForSliderCap,
    validationMaxCap,
  });
  if (!Number.isFinite(minIn) || !Number.isFinite(maxIn) || minIn > maxIn + 1e-8) return null;
  return { minIn, maxIn };
}

/**
 * 在已加载策略中找「券可跟单」的首个策略。
 * 优先：preferred 券 + 按列表顺序首个可下单策略；否则按策略顺序 + 首张可用券。
 * @returns {{ strategyId: string|number, voucherUserCouponId: string } | null}
 */
export function findAicopyVoucherFollowTarget({
  strategies,
  strategyDetails,
  vouchers,
  preferredVoucherUserCouponId,
  availableBalance = "0",
}) {
  if (!Array.isArray(strategies) || !strategies.length) return null;
  if (!Array.isArray(vouchers) || !vouchers.length) return null;

  const preferred =
    preferredVoucherUserCouponId != null && String(preferredVoucherUserCouponId).trim() !== ""
      ? String(preferredVoucherUserCouponId).trim()
      : null;

  const boundsFor = (strategyId) =>
    computeAicopyStrategyVoucherRangeBounds(strategyDetails?.[strategyId], availableBalance);

  if (preferred) {
    const preferredVoucher = vouchers.find((v) => String(v.id) === preferred);
    if (preferredVoucher) {
      for (const strategy of strategies) {
        const sid = strategy?.strategyId;
        if (sid == null || sid === "") continue;
        const bounds = boundsFor(sid);
        if (!bounds) continue;
        if (isVoucherItemSelectableForFollow(preferredVoucher, bounds.minIn, bounds.maxIn)) {
          return { strategyId: sid, voucherUserCouponId: preferred };
        }
      }
    }
  }

  for (const strategy of strategies) {
    const sid = strategy?.strategyId;
    if (sid == null || sid === "") continue;
    const bounds = boundsFor(sid);
    if (!bounds) continue;
    const hit = vouchers.find((v) => isVoucherItemSelectableForFollow(v, bounds.minIn, bounds.maxIn));
    if (hit?.id != null) {
      return { strategyId: sid, voucherUserCouponId: String(hit.id) };
    }
  }

  return null;
}

export function scrollToAicopyStrategyCard(strategyId) {
  if (typeof window === "undefined" || strategyId == null || strategyId === "") return false;
  const id = String(strategyId).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  const el = document.querySelector(`[data-aicopy-strategy-id="${id}"]`);
  if (!el) return false;
  try {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  } catch {
    el.scrollIntoView(true);
  }
  return true;
}
